import React, {  useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import MyContext from "../MyContext/MyContext";

const BestSellsOne = () => {
  const { data } = useContext(MyContext);

  // ---- Flatten products from all categories ----
  const allProducts = useMemo(() => {
    if (!Array.isArray(data)) return [];
    return data.flatMap((cat) =>
      (cat.products || []).map((p) => ({
        ...p,
        routing_category: cat.routing_category?.toLowerCase(),
      }))
    );
  }, [data]);

  // ---- Random 4 products ----
  const randomProducts = useMemo(() => {
    const shuffled = [...allProducts].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, 4);
  }, [allProducts]);



  return (
    <section className="best sells pb-80">
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">Daily Best Sells</h5>
          </div>
        </div>

        <div className="row g-12">
          {/* ---------------- LEFT SIDE ---------------- */}
          <div className="col-xxl-8">
            <div className="row gy-4">

              {randomProducts.length > 0 &&
                randomProducts.map((p, index) => (
                  <div className="col-md-6" key={p.id}>
                    <div className="product-card style-two h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 flex-align gap-16">

                      <div>
                        <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                          Sale
                        </span>

                        <Link
                          to={`/shop/${p.routing_category}/${p.id}`}
                          className="product-card__thumb flex-center"
                        >
                          <img src={p.image} alt={p.title} />
                        </Link>

                        {/* countdown stays the same */}
                    
                      </div>

                      {/* ----------- PRODUCT CONTENT ----------- */}
                      <div className="product-card__content">
                        <div className="product-card__price mb-16">
                          <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                            ${p.price?.original}
                          </span>
                          <span className="text-heading text-md fw-semibold">
                            ${p.price?.current}{" "}
                            <span className="text-gray-500 fw-normal">/Qty</span>
                          </span>
                        </div>

                        <div className="flex-align gap-6">
                          <span className="text-xs fw-bold text-gray-600">
                            {p.rating?.stars}
                          </span>
                          <span className="text-15 fw-bold text-warning-600 d-flex">
                            <i className="ph-fill ph-star" />
                          </span>
                          <span className="text-xs fw-bold text-gray-600">
                            ({p.rating?.reviews_count})
                          </span>
                        </div>

                        <h6 className="title text-lg fw-semibold mt-12 mb-8">
                          <Link
                            to={`/shop/${p.routing_category}/${p.id}`}
                            className="link text-line-2"
                          >
                            {p.title}
                          </Link>
                        </h6>

                        <div className="flex-align gap-4">
                          <span className="text-main-600 text-md d-flex">
                            <i className="ph-fill ph-storefront" />
                          </span>
                          <span className="text-gray-500 text-xs">
                            {p.details?.Brand || "By Store"}
                          </span>
                        </div>

                        <div className="mt-12">
                          <div className="progress w-100 bg-color-three rounded-pill h-4">
                            <div
                              className="progress-bar bg-main-600 rounded-pill"
                              style={{ width: "40%" }}
                            />
                          </div>
                          <span className="text-gray-900 text-xs fw-medium mt-8">
                            Sold: 18/35
                          </span>
                        </div>

                    
                      </div>
                    </div>
                  </div>
                ))}

            </div>
          </div>

          {/* ---------------- RIGHT SIDE (STATIC) ---------------- */}
<div className="col-xxl-4">
  <div
    style={{
      position: "relative",
      minHeight: "420px",
      padding: "32px",
      borderRadius: "20px",
      overflow: "hidden",
      background: "linear-gradient(135deg, #6f3cff, #b86bff)",
      boxShadow: "0 30px 70px rgba(111,60,255,0.35)",
    }}
  >
    {/* BACKGROUND BLOBS – FORCE TO BACK */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-70px",
          right: "-70px",
          width: "220px",
          height: "220px",
          borderRadius: "50%",
          background: "#ffcc70",
          opacity: 0.45,
          filter: "blur(80px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-80px",
          left: "-80px",
          width: "240px",
          height: "240px",
          borderRadius: "50%",
          background: "#00ffd5",
          opacity: 0.4,
          filter: "blur(90px)",
        }}
      />
    </div>

    {/* CONTENT */}
    <div
      style={{
        position: "relative",
        zIndex: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        color: "#fff",
      }}
    >
      <div>
        <span
          style={{
            display: "inline-block",
            background: "#fff",
            color: "#6f3cff",
            padding: "6px 14px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: 700,
            marginBottom: "16px",
          }}
        >
          Limited Deal
        </span>

        <h3
          style={{
            fontSize: "32px",
            fontWeight: 800,
            lineHeight: 1.2,
            marginBottom: "12px",
          }}
        >
          Daily Best <br /> Sells
        </h3>

        <p
          style={{
            fontSize: "14px",
            opacity: 0.85,
            maxWidth: "280px",
            marginBottom: "20px",
          }}
        >
          Shop our most popular products with exclusive discounts.
        </p>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            marginBottom: "24px",
          }}
        >
          <span style={{ fontSize: "36px", fontWeight: 800 }}>
            50%
          </span>
          <span style={{ opacity: 0.8 }}>OFF</span>
        </div>

        {/* COUNTDOWN LOOK */}
        <div style={{ display: "flex", gap: "10px" }}>
          {["12", "45", "30"].map((val, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.2)",
                borderRadius: "10px",
                padding: "8px 12px",
                textAlign: "center",
                minWidth: "56px",
                backdropFilter: "blur(8px)",
              }}
            >
              <div style={{ fontWeight: 700 }}>{val}</div>
              <div
                style={{
                  fontSize: "11px",
                  opacity: 0.75,
                }}
              >
                {i === 0 ? "Hrs" : i === 1 ? "Min" : "Sec"}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA — GUARANTEED VISIBLE */}
      <Link
        to="/shop"
        style={{
          marginTop: "28px",
          background: "#111",
          color: "#fff",
          padding: "14px 22px",
          borderRadius: "999px",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          textDecoration: "none",
          boxShadow: "0 8px 20px rgba(0,0,0,0.35)",
        }}
      >
        Shop Now
        <i className="ph ph-arrow-right" />
      </Link>
    </div>
  </div>
</div>



        </div>

      </div>
    </section>
  );
};

export default BestSellsOne;
